<template>
  <div class="report-user-content">
    <vue-perfect-scrollbar
      
      class="report-user-scroll-area"
      :suppressScrollX="true"
    >
      <div class="row">  <!-- match-height -->
        <div class="col-md-12 col-lg-6">
          <b-card no-body>
            <b-card-header>
              <!-- title and subtitle -->
              <div>
                <b-card-title class="mb-1"> Line Chart </b-card-title>
                <b-card-sub-title>Commercial networks</b-card-sub-title>
              </div>
              <!--/ title and subtitle -->

              <!-- datepicker -->
              <div class="d-flex align-items-center">
                <feather-icon icon="CalendarIcon" size="16" />
                <flat-pickr
                  v-model="rangePicker"
                  :config="{ mode: 'range' }"
                  class="form-control flat-picker bg-transparent border-0 shadow-none"
                  placeholder="YYYY-MM-DD"
                />
              </div>
              <!-- datepicker -->
            </b-card-header>

            <b-card-body>
              <vue-apex-charts
                type="area"
                height="400"
                :options="lineAreaChartSpline.chartOptions"
                :series="lineAreaChartSpline.series"
              />
            </b-card-body>
          </b-card>
        </div>
        <div class="col-md-6 col-lg-3">
          <b-card no-body>
            <b-card-header>
              <!-- title and subtitle -->
              <div>
                <b-card-title class="mb-1"> Usuários </b-card-title>
                <b-card-sub-title>Notícias enviadas</b-card-sub-title>
              </div>
              <!--/ title and subtitle -->

              <!-- badge -->
              <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
                <h5 class="font-weight-bolder mb-0 mr-1">$ 100,000</h5>
                <b-badge variant="light-secondary">
                  <feather-icon
                    icon="ArrowDownIcon"
                    size="16"
                    class="text-danger mr-25"
                  />
                  <span class="align-middle">20%</span>
                </b-badge>
              </div>
              <!--/ badge -->
            </b-card-header>

            <b-card-body>
              <vue-apex-charts
                type="line"
                height="400"
                :options="lineChartSimple.chartOptions"
                :series="lineChartSimple.series"
              />
            </b-card-body>
          </b-card>
        </div>
        <div class="col-md-6 col-lg-3">
          <b-card no-body>
            <b-card-header>
              <!-- title and subtitle -->
              <div>
                <b-card-title class="mb-1"> Usuários </b-card-title>
                <b-card-sub-title>Notícias enviadas</b-card-sub-title>
              </div>
              <!--/ title and subtitle -->

              <!-- badge -->
              <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
                <h5 class="font-weight-bolder mb-0 mr-1">$ 100,000</h5>
                <b-badge variant="light-secondary">
                  <feather-icon
                    icon="ArrowDownIcon"
                    size="16"
                    class="text-danger mr-25"
                  />
                  <span class="align-middle">20%</span>
                </b-badge>
              </div>
              <!--/ badge -->
            </b-card-header>

            <b-card-body>
              <vue-apex-charts
                type="line"
                height="400"
                :options="lineChartSimple.chartOptions"
                :series="lineChartSimple.series"
              />
            </b-card-body>
          </b-card>
        </div>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BBadge,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import VueApexCharts from "vue-apexcharts";
import { $themeColors } from "@themeConfig";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// colors
const chartColors = {
  column: {
    series1: "#826af9",
    series2: "#d2b0ff",
    bg: "#f8d3ff",
  },
  success: {
    shade_100: "#7eefc7",
    shade_200: "#06774f",
  },
  donut: {
    series1: "#ffe700",
    series2: "#00d4bd",
    series3: "#826bf8",
    series4: "#2b9bf4",
    series5: "#FFA1A1",
  },
  area: {
    series3: "#a4f8cd",
    series2: "#60f2ca",
    series1: "#2bdac7",
  },
};

export default {
  components: {
    VuePerfectScrollbar,
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    flatPickr,
  },
  data() {
    return {
      rangePicker: ["2019-05-01", "2019-05-10"],
      lineChartSimple: {
        series: [
          {
            data: [
              280,
              200,
              220,
              180,
              270,
              250,
              70,
              90,
              200,
              150,
              160,
              100,
              150,
              100,
              50,
            ],
          },
        ],
        chartOptions: {
          chart: {
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          markers: {
            strokeWidth: 7,
            strokeOpacity: 1,
            strokeColors: [$themeColors.light],
            colors: [$themeColors.warning],
          },
          colors: [$themeColors.warning],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          tooltip: {
            custom(data) {
              return `${'<div class="px-1 py-50"><span>'}${
                data.series[data.seriesIndex][data.dataPointIndex]
              }%</span></div>`;
            },
          },
          xaxis: {
            categories: [
              "7/12",
              "8/12",
              "9/12",
              "10/12",
              "11/12",
              "12/12",
              "13/12",
              "14/12",
              "15/12",
              "16/12",
              "17/12",
              "18/12",
              "19/12",
              "20/12",
              "21/12",
            ],
          },
          yaxis: {
            // opposite: isRtl,
          },
        },
      },

      lineAreaChartSpline: {
        series: [
          {
            name: "João",
            data: [10, 5, 15, 9, 20, 30, 50, 5, 10, 15, 10, 10, 10],
          },
          {
            name: "Maria",
            data: [5, 15, 20, 21, 5, 15, 15, 15, 10, 20, 12, 14, 8],
          },
          {
            name: "Pedrinho",
            data: [3, 1, 5, 7, 4, 0, 10, 1, 12, 5, 9, 8, 4],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: false,
            curve: "straight",
          },
          legend: {
            show: true,
            position: "top",
            horizontalAlign: "left",
            fontSize: "14px",
            fontFamily: "Montserrat",
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
          },
          xaxis: {
            categories: [
              "7/12",
              "8/12",
              "9/12",
              "10/12",
              "11/12",
              "12/12",
              "13/12",
              "14/12",
              "15/12",
              "16/12",
              "17/12",
              "18/12",
              "19/12",
              "20/12",
            ],
          },
          yaxis: {
            // opposite: isRtl
          },
          fill: {
            opacity: 1,
            type: "solid",
          },
          tooltip: {
            shared: false,
          },
          colors: [
            chartColors.area.series3,
            chartColors.area.series2,
            chartColors.area.series1,
          ],
        },
      },
    };
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };
    return {
      perfectScrollbarSettings,
    };
  },
};
</script>

<style></style>
